<template>
    <div class="animallList">
        <div class="animallBox">
            <div class="leftClass">
                <div class="classBox">
                    <div v-for="(item, index) in categoryList" :key="item.id" class="classItem">
                        <div class="classTitle">{{ item.name }}</div>
                        <div @click="selectChange(item2, index)"
                            :class="(item2.id == query.type1 && index == 0) || (item2.id == query.type2 && index == 1) ? 'active' : ''"
                            v-for="item2 in item.children" :key="item2.id" class="valItem ">
                            <span> {{ item2.name }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="rightList">
                <div @click="$openUrl(item.jump_url)" v-for="item in datalist" :key="item.id" class="rightListItem">
                    <div class="headBox">
                        <img class="headImage" :src="item.cover" alt="" />
                        <img v-if="item.play_btn_show == 2" class="play" src="@/assets/index/playBtn.png" alt="">
                    </div>
                    <div class="infoBox">
                        <div class="info1">
                            <div class="tag">{{ item.black_label }}</div>
                            <div class="date">{{ item.date }}</div>
                        </div>
                        <div class="text">
                            {{ item.title }}
                        </div>
                        <div class="footBox">
                            <div v-for="(tag,index2) in item.tags" :key="index2" class="footTag">{{ tag.content }}</div>
                        </div>
                    </div>
                </div>

                <div class="Pagination">
                    <myPagination @current-change="pageChange" :allNum="total" :limit="query.limit"></myPagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import myPagination from '@/components/myPagination.vue'
import { get_category, get_list } from '@/api/cases.js'
export default {
    components: {
        myPagination,
    },
    data() {
        return {
            categoryList: [],
            query: {
                page: 1,
                limit: 6,
                type1: 0,
                type2: 0,
            },
            total: 0,
            datalist: [],
        }
    },
    created() {
        this.getCategoryList()
        this.getListData()
        let { type1, type2 } = this.$route.query
        if (type1) {
            this.query.type1 = type1
        }
        if (type2) {
            this.query.type2 = type2
        }
    },
    mounted() {

    },
    methods: {
        getCategoryList() {
            get_category().then(res => {
                this.categoryList = res.data
            })
        },
        getListData() {
            get_list(this.query).then(res => {
                this.datalist = res.data.list
                this.total = res.data.count
            })
        },
        selectChange(data, index) {
            if (index == 0) {
                this.query.type1 = data.id
            } else if (index == 1) {
                this.query.type2 = data.id
            }
            this.query.page = 1
            this.getListData()
        },
        pageChange(page) {
            this.query.page = page
            this.getListData()
        },
    }
}
</script>

<style scoped lang="scss">
.animallList {
    background: #fff;


    .animallBox {
        width: 1200px;
        margin: auto;
        display: flex;
        border-top: 1px solid #888888;
        padding-top: 60px;
    }

    .leftClass {
        width: 308px;

        .classBox {

            .classItem {
                margin-bottom: 30px;

                .classTitle {
                    font-size: 24px;
                    color: #000000;
                    line-height: 24px;
                    font-weight: bold;
                    margin-bottom: 20px;
                }

                .valItem {
                    height: 30px;
                    line-height: 30px;
                    margin-bottom: 9px;
                    cursor: pointer;

                    span {
                        font-size: 16px;
                        color: #010101;
                        font-weight: 400;
                        display: inline-block;
                        padding: 0 28px;
                    }
                }

                .active {

                    span {
                        color: #fff;
                        background: #000000;
                        font-weight: bold;
                    }
                }
            }
        }
    }

    .rightList {
        width: calc(100% - 308px);
        display: flex;
        flex-wrap: wrap;

        .rightListItem {
            width: 277px;
            margin-right: 30px;
            margin-bottom: 30px;
            cursor: pointer;

            &:nth-child(3n) {
                margin-right: 0px;
            }

            .headBox {
                position: relative;
                width: 100%;

                .headImage {
                    width: 100%;
                    height: 160px;
                    object-fit: cover;
                    display: block;
                }

                .play {
                    width: 46px;
                    height: 46px;
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    cursor: pointer;
                }
            }

            .infoBox {
                padding: 22px 0 30px 0;

                .info1 {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    .tag {
                        font-size: 16px;
                        color: #FFFEFE;
                        height: 30px;
                        line-height: 30px;
                        background: #000000;
                        padding: 0 10px;
                    }

                    .date {
                        font-size: 14px;
                        color: #000000;
                        font-weight: 400;
                    }
                }

                .text {
                    margin-top: 15px;
                    font-size: 18px;
                    height: 114px;
                    line-height: 22px;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 5;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .footBox {
                    margin-top: 30px;
                    display: flex;
                    flex-wrap: wrap;

                    .footTag {
                        font-weight: 400;
                        font-size: 14px;
                        color: #000000;
                        line-height: 20px;
                        margin-right: 30px;
                    }
                }
            }
        }
    }
}

.Pagination {
    display: flex;
    justify-content: center;
    width: 100%;
    padding-bottom: 116px;
}

@media screen and (max-width:1200px) {
    .animallList {
        background: #fff;

        .animallBox {
            width: 100%;
            margin: auto;
            display: block;
        }

        .leftClass {
            width: 100%;

            .classBox {
                display: flex;
                overflow: auto;

                .classItem {
                    width: 50%;
                    flex-shrink: 0;
                    margin-bottom: 30px;

                    .classTitle {
                        text-align: center;
                    }

                    .valItem {
                        text-align: center;

                        span {
                            font-size: 16px;
                            color: #010101;
                            font-weight: 400;
                            display: inline-block;
                            padding: 0 28px;
                        }
                    }

                    .active {

                        span {
                            color: #fff;
                            background: #000000;
                            font-weight: bold;
                        }
                    }
                }
            }
        }

        .rightList {
            width: 100%;
            padding: 0 20px;
            box-sizing: border-box;
            display: flex;
            flex-wrap: wrap;

            .rightListItem {
                width: calc((100% - 20px) / 2);
                margin-right: 0px;
                margin-bottom: 30px;

                &:nth-child(2n - 1) {
                    margin-right: 20px;
                }

                .headBox {
                    position: relative;
                    width: 100%;

                    .headImage {
                        width: 100%;
                        height: auto;
                        aspect-ratio: 270 / 160;
                        object-fit: cover;
                        display: block;
                    }

                    .play {
                        width: 46px;
                        height: 46px;
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%, -50%);
                        cursor: pointer;
                    }
                }

                .infoBox {
                    padding: 22px 0 30px 0;

                    .info1 {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        .tag {
                            font-size: 16px;
                            color: #FFFEFE;
                            height: 30px;
                            line-height: 30px;
                            background: #000000;
                            padding: 0 10px;
                        }

                        .date {
                            font-size: 14px;
                            color: #000000;
                            font-weight: 400;
                        }
                    }

                    .text {
                        margin-top: 15px;
                        font-size: 18px;
                        line-height: 24px;
                    }

                    .footBox {
                        margin-top: 30px;
                        display: flex;
                        flex-wrap: wrap;

                        .footTag {
                            font-weight: 400;
                            font-size: 14px;
                            color: #000000;
                            line-height: 20px;
                            margin-right: 30px;
                        }
                    }
                }
            }
        }
    }

    .Pagination {
        padding-bottom: 50px;
    }
}
</style>